import Request from '../../data/request';
import DatetimeUtils from "../../utils/datetime-utils";
import TimeReport from "../../../model2/time-report/time-report";

export default class ApiTimeReport {


    static getTimeReports(params:any) {
        return new Request(this,'POST','uds/time-reports', params);
    }


    static update(timeReportId:ID, params:any) {

        if (params.startMoment) params.startMoment = DatetimeUtils.momentToUTCISODatetime(params.startMoment)
        if (params.endMoment) params.endMoment = DatetimeUtils.momentToUTCISODatetime(params.endMoment)
        if (params.date) params.date = params.date.format("YYYY-MM-DD")

        return new Request(this,'POST','time-report/'+timeReportId+'/update', params);

        // return new Request(this,'PUT','time-report/'+timeReportId+'/update', {
        //     reportedTimeMinutes : reportedMinutes,
        //     startMoment         : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
        //     endMoment           : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
        // })
    }

    static delete(timeReportId:ID) {
        return new Request(this,'POST','time-report/'+timeReportId+'/delete', {})
    }

    static createForTaskMessage(taskMessageId:ID, reportedMinutes:number|null,
                         startMoment?:Moment, endMoment?:Moment, needMyTimeResponse?: boolean) {

        return new Request(this,'POST','time-report/create-for-task', {
            taskMessageId       : taskMessageId,
            reportedTimeMinutes : reportedMinutes,
            startMoment         : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
            endMoment           : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
            needMyTimeResponse  : needMyTimeResponse
        })
    }

    static createForTask(taskId:ID,
                         date:Moment,
                         reportedMinutes:number|null,
                         userId:ID, // user we report for
                         message:string|null,
                         messageRTF:any,
                         needMyTimeResponse     : boolean,
                         startMoment?:Moment, endMoment?:Moment) {

        return new Request(this,'POST','time-report/create-for-task', {
            userId              : userId,
            taskId              : taskId,
            date                : date.format("YYYY-MM-DD"),
            reportedTimeMinutes : reportedMinutes,
            message             : message,
            messageRTF          : messageRTF,
            startMoment         : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
            endMoment           : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
            needMyTimeResponse  : needMyTimeResponse
        })
    }

    static create(timeReport:TimeReport, needMyTimeResponse:boolean) {
        return new Request(this,'POST','time-report/create-for-task', {
            userId              : timeReport.userId,
            taskId              : timeReport.taskId,
            date                : timeReport.date!.format("YYYY-MM-DD"),
            reportedTimeMinutes : timeReport.reportedTimeMinutes,
            message             : timeReport.message,
            messageRTF          : timeReport.messageRTF,
            startMoment         : timeReport.startMoment ? DatetimeUtils.momentToUTCISODatetime(timeReport.startMoment) : undefined,
            endMoment           : timeReport.endMoment ? DatetimeUtils.momentToUTCISODatetime(timeReport.endMoment) : undefined,
            isBillable          : timeReport.isBillable,
            needMyTimeResponse  : needMyTimeResponse
        })
    }

    static getById(timeReportId:ID) {
        return new Request(this,'GET','time-report/{0}'.f(timeReportId));
    }

}
